import * as Types from '../../generated/graphql.types';

import gql from 'graphql-tag';
export type CoursePreviewFragment = { __typename?: 'Course', id: string, name: string, assetId: number, updatedAt: string, updatedBy: string, routeChangeAlert?: { __typename?: 'RouteChangeAlert', courseId: string, archiveFilePath: string, createdAt: string } | null };

export type UserPreviewFragment = { __typename?: 'User', id: string, name: string };

export type AdminPreviewFragment = { __typename?: 'Administrator', id: string, name: string };

export type SpotParamsFragment = { __typename?: 'Spot', courseId: string, spotType: Types.SpotType, name?: string | null, description?: string | null, parentSpotId?: string | null, note?: string | null, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } };

export type SpotForRoutingFragment = { __typename?: 'Spot', id: string, assetId: number, courseId: string, spotType: Types.SpotType, name?: string | null, description?: string | null, order: number, parentSpotId?: string | null, note?: string | null, hasMusic: boolean, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } };

export type SpotForContentsEditFragment = { __typename?: 'Spot', id: string, parentSpotId?: string | null, spotType: Types.SpotType, order: number, name?: string | null, description?: string | null, geofenceRadius: number, narrationText?: string | null, hasCafe: boolean, hasRestroom: boolean, hasPaidParking: boolean, hasFreeParking: boolean, hasRestaurant: boolean, hasEvCharger: boolean, musicQuestion?: string | null, narrationTextForTtsBeforeMusic?: string | null, narrationTextForTtsAfterMusic?: string | null, note?: string | null, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } };

export const CoursePreviewFragmentDoc = gql`
    fragment CoursePreview on Course {
  id
  name
  assetId
  updatedAt
  updatedBy
  routeChangeAlert {
    courseId
    archiveFilePath
    createdAt
  }
}
    `;
export const UserPreviewFragmentDoc = gql`
    fragment UserPreview on User {
  id
  name
}
    `;
export const AdminPreviewFragmentDoc = gql`
    fragment AdminPreview on Administrator {
  id
  name
}
    `;
export const SpotParamsFragmentDoc = gql`
    fragment SpotParams on Spot {
  courseId
  spotType
  name
  coordinate {
    lat
    lon
  }
  description
  parentSpotId
  note
}
    `;
export const SpotForRoutingFragmentDoc = gql`
    fragment SpotForRouting on Spot {
  id
  assetId
  courseId
  spotType
  name
  coordinate {
    lat
    lon
  }
  description
  order
  parentSpotId
  note
  hasMusic
}
    `;
export const SpotForContentsEditFragmentDoc = gql`
    fragment SpotForContentsEdit on Spot {
  id
  parentSpotId
  spotType
  order
  coordinate {
    lat
    lon
  }
  name
  description
  geofenceRadius
  narrationText
  hasCafe
  hasRestroom
  hasPaidParking
  hasFreeParking
  hasRestaurant
  hasEvCharger
  musicQuestion
  narrationTextForTtsBeforeMusic
  narrationTextForTtsAfterMusic
  note
}
    `;